import React from 'react'

export const HelpPage = () => <div>This is from my help component</div>
